import { http } from '../support/http/http'
import { statusResponse } from './responseService'
export default class Base {
  constructor (api) {
    this.api = api
    this.http = http
  }

  list = () => {
    return new Promise((resolve, reject) => {
      http.get(this.api).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'list'))
      })
    })
  }

  get = ($id) => {
    return new Promise((resolve, reject) => {
      http.get(`${this.api}/${$id}`).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'get', 'item'))
      })
    })
  }

  create = ($data) => {
    return new Promise((resolve, reject) => {
      http.post(this.api, $data).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'create'))
      })
    })
  }

  update = ($data) => {
    return new Promise((resolve, reject) => {
      http.put(`${this.api}/${$data.id}`, $data).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'update'))
      })
    })
  }

  remove = ($id) => {
    return new Promise((resolve, reject) => {
      http.delete(`${this.api}/${$id}`).then((response) => {
        resolve(response)
      }).catch((err) => {
        reject(statusResponse(err, 'remove'))
      })
    })
  }
}
